import { get } from '@/core/api/api.service';

export interface ICoveoEnabledResponse {
  result: boolean;
}

export interface IRingSearchEnabledResponse {
  result: boolean;
}

export const requestCoveoSearchFlag = (): Promise<ICoveoEnabledResponse> => {
  const endpoint = '/api/coveo-enabled';
  return get(endpoint);
};

export const requestRingSearchEnabled =
  (): Promise<IRingSearchEnabledResponse> => {
    const endpoint = '/api/ring-search-enabled';
    return get(endpoint);
  };
